import React from "react";
import {connect} from "react-redux";
import {Box, styled, Typography} from "@mui/material";
import {IProjectSection} from "../../interfaces/components/sections/IProjectSection";
import {ILanguageTokens} from "../../localization/LanguageTokens";
import {RootState} from "../../redux/store";
import ProjectVideo from "./ProjectVideo";
import ProjectImage from "./ProjectImage";

const Root = styled(Box)(({theme}) => ({
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.palette.secondary.main,
    borderRadius: theme.spacing(1), // todo
    [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(2),
        gap: theme.spacing(1),
    },
    [theme.breakpoints.up('sm')]: {
        padding: theme.spacing(4),
        gap: theme.spacing(2),
    },
    userSelect: 'text',
}));
const DescriptionText = styled(Typography)(({theme}) => ({
    whiteSpace: 'pre-line',
    userSelect: 'text',
}));

interface IProps {
    languageTokens: ILanguageTokens;
    section: IProjectSection;
}

function ProjectSection(props: IProps) {
    const {
        section: {
            image,
            imageName,
            descriptionHeader,
            description,
            size,
            video,
        }
    } = props;

    return <Root
        id={`ProjectSection_${descriptionHeader}`}
    >

        {video ? <ProjectVideo video={video} description={imageName}/> : null}
        {image ? <ProjectImage image={image} size={size} description={imageName}/> : null}
        <Box>

            <Typography
                id={'DescriptionHeader'}
                variant={"h2"}
                pb={1}
            >
                {descriptionHeader}
            </Typography>

            <DescriptionText
                id={'DescriptionText'}
                variant={"h6"}
            >
                {description.split('__LINEBREAK__').map((line, index) => (
                    <React.Fragment key={index}>
                        {line}
                        <br />

                    </React.Fragment>
                ))}
            </DescriptionText>
        </Box>
    </Root>

}

const mapStateToProps = (state: RootState) => ({
    languageTokens: state.language.languageTokens,
});

const mapActionsToProps = {
};

export default connect(mapStateToProps, mapActionsToProps)(ProjectSection);
